<template>
  <NylonOptionPanel collapsible :embedded="embedded">
    <template #header>
      <h4>Ink Colors</h4>
      <a href="#" class="help-link" @click.prevent="$emit('help', 'numInks')">?</a>
    </template>
    <NylonOptionGrid compact>
      <button v-for="inkCount in inkCounts" :key="inkCount" class="nylon-OptionGrid-option" :class="{ active: inkCount == numInks }" @click.prevent="$emit('update:numInks', inkCount)">
        <div class="text">
          <span class="heading">{{ inkCount }}</span>
        </div>
      </button>
    </NylonOptionGrid>
  </NylonOptionPanel>

  <NylonOptionPanel collapsible :embedded="embedded">
    <template #header>
      <h4>Ink Type</h4>
      <a href="#" class="help-link" @click.prevent="$emit('help', 'inkType')">?</a>
    </template>
    <NylonOptionGrid>
      <button
        v-for="option in inkTypes"
        :key="option.name"
        class="nylon-OptionGrid-option"
        :class="{ active: inkType === option.name }"
        :title="option.title"
        @click.prevent="$emit('update:inkType', option.name)"
      >
        <div class="text">
          <span class="heading">{{ option.heading }}</span>
          <p>{{ option.description }}</p>
        </div>
      </button>
    </NylonOptionGrid>
  </NylonOptionPanel>

  <NylonOptionPanel collapsible :embedded="embedded">
    <template #header>
      <h4>Ink Options</h4>
    </template>
    <NylonOptionGrid>
      <button
        v-for="option in inkEffects"
        :key="option.name"
        class="nylon-OptionGrid-option"
        :class="{ active: inkEffect === option.name }"
        :title="option.title"
        @click.prevent="$emit('update:inkEffect', option.name)"
      >
        <div class="text">
          <span class="heading">{{ option.heading }}</span>
          <p>{{ option.description }}</p>
        </div>
      </button>
    </NylonOptionGrid>
  </NylonOptionPanel>
</template>

<script>
import NylonOptionGrid from "@/nylon/components/NylonOptionGrid.vue";
import NylonOptionPanel from "@/nylon/components/NylonOptionPanel.vue";

/**
 * The screen-print ink choices for one print location — ink count, ink type,
 * ink effect — as the product creator's option panels. Used for a back print's
 * own inks (PRO-3173) in the submission wizard and the account edit page; the
 * front's panels predate it and are still inline on both pages.
 *
 * Props mirror the location's input keys (v-model:num-inks / :ink-type /
 * :ink-effect); `inkTypes` / `inkEffects` are the mixin's priced option tables.
 * Emits `help` with the help modal the caller should open.
 */
export default {
  name: "ScreenPrintInkPanels",
  components: { NylonOptionGrid, NylonOptionPanel },
  props: {
    numInks: { type: Number, required: true },
    inkType: { type: String, required: true },
    inkEffect: { type: String, required: true },
    inkTypes: { type: Object, required: true },
    inkEffects: { type: Object, required: true },
    embedded: { type: Boolean, default: false },
  },
  emits: ["update:numInks", "update:inkType", "update:inkEffect", "help"],
  data() {
    return { inkCounts: [1, 2, 3, 4, 5, 6, 7, 8] };
  },
};
</script>
